import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';

export const authConfigOkta: AuthConfig = {
  issuer: `https://invisionsolutions.okta.com/oauth2/default`,
  redirectUri: `${window.location.origin}/auth/login`,
  clientId: environment.clientIdOkta,
  scope: 'openid profile email address phone',
  requestAccessToken: true,
};

export const PackagingType = {
  Ship: 'ship',
  RX: 'rx',
};

export const AddNewPopupType = {
  Location: 'location',
  Type: 'type',
  Supplier: 'supplier',
};

export type Pagination = {
  packaging_type: string;
  page: number;
  per_page: number;
  search_by: string;
  inventory_type_id: string;
  state_id: string;
  purchase_date_start: string;
  purchase_date_end: string;
  sort_key: string;
  sort_type: 'asc' | 'desc' | '';
};

export const SortType: { [key: string]: 'asc' | 'desc' | '' } = {
  Ascending: 'asc',
  Descending: 'desc',
};

export enum ModalPopup {
  ChangePackaging,
}

export type PatientData = {
  page: number;
  per_page: number;
  sort_type: 'asc' | 'desc' | '';
  sort_key: string;
  search?: string;
  user_id?: string;
  type?: string;
  start?: string;
  end?: string;
  lng?: string;
  id?: number;
  coming_from?: number;
  user_medscheck_responses_id?: number;
  order_type?: string;
  report_type?: string;
  server_location?: number;
  date_from?: string;
  date_to?: string;
  is_manual?: number;
  isDashboard?:number;
};

export interface CalendlyData {
  id: number;
  user_medscheck_response_id: number;
  assigned_to: string;
  call_start_time: string;
  call_end_time: string;
  invitee_full_name: string;
  start_date: string;
  end_date: string;
  start_time: string;
  end_time: string;
  duration: string;
}

export type ReportPaginateData = {
  page: number;
  per_page: number;
  sort_type: 'asc' | 'desc' | '';
  sort_key: string;
  search?: string;
  user_id?: string;
  type?: string;
  start?: string;
  end?: string;
  lng?: string;
  id?: number;
  report_type?: string;
  server_location?: string;
  coming_from?: number;
  user_medscheck_responses_id?: number;
};
